import React, { useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import "./App.css";
import LoginPage from "./components/LoginPage";
import RecoverForm from "./components/RecoverForm";
import CreateAccountForm from "./components/CreateAccount";
import ResetPassword from "./components/ResetPassword.jsx";
import Insights from "./components/Insights";
import Team from "./components/Team";
import Settings from "./components/Settings";
import Layout from "./components/Layout";
import CampaignDetail from "./components/CampaignDetail";
import { AuthProvider, useAuth, authenticateUser } from './components/context/AuthContext.tsx';

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

function AppRoutes() {
  const { token, isLoading } = useAuth();
  const navigate = useNavigate();

  if (isLoading) {
    return <div>Carregando...</div>;
  }

  const PrivateRoute = ({ children }) => {
    const { token } = useAuth();
    return token ? children : <Navigate to="/login" />;
  };

  return (
    <div className="App">
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<RecoverForm />} />
        <Route path="/create-account" element={<CreateAccountForm />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout activePage="insights">
                <Insights />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/team"
          element={
            <PrivateRoute>
              <Layout activePage="team">
                <Team />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Layout activePage="settings">
                <Settings />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/campaign-detail"
          element={
            <PrivateRoute>
              <Layout activePage="insights">
                <CampaignDetail />
              </Layout>
            </PrivateRoute>
          }
        />
        
        <Route path="*" element={<Navigate to={token ? "/" : "/login"} />} />
      </Routes>
    </div>
  );
}

export default App;
